<template>
  <page v-if="stylesLoaded" class="full-height">
    <div>
      <div
        class="flex items-end justify-between page-header-content pb-4 md:items-start"
      >
        <div class="flex-col align-items-center flex-wrap">
          <h1 class="schedule-board-title mr-2 page-header-1">Schedule</h1>
          <h1 class="schedule-board-date page-header-2">{{ title }}</h1>
        </div>
        <div class="flex md:items-center md:gap-4">
          <AppointmentColorsLegend />
          <div class="hidden md:flex">
            <SlotWrapper>
              <template #actions>
                <schedule-board-filters
                  class="schedule-board-filters"
                ></schedule-board-filters>
              </template>
            </SlotWrapper>
          </div>
          <div class="md:hidden">
            <button
              type="button"
              class="text-black bg-white border hover:bg-blue-800 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-lg p-2.5 text-center inline-flex items-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              @click="toggleFilterModal"
            >
              <i class="fa-regular fa-filter"></i>
            </button>
          </div>
          <CheckAvailabilityModal class="md:hidden" />
        </div>
        <Modal
          v-if="filterModal"
          title="Filter"
          @hide-modal="toggleFilterModal"
          @submit="toggleFilterModal"
        >
          <div>
            <SlotWrapper>
              <template #actions>
                <schedule-board-filters
                  class="schedule-board-filters"
                ></schedule-board-filters>
              </template>
            </SlotWrapper>
          </div>
        </Modal>
      </div>
      <schedule-board class="schedule-board mt-4"></schedule-board>
    </div>
  </page>
</template>

<script setup lang="ts">
import moment from "moment-timezone";
import { computed, onBeforeMount, ref } from "vue";
import { onMounted } from "vue";
import { useStore } from "vuex";

import Modal from "@/components/Modal.vue";
import Page from "@/components/Page.vue";
import SlotWrapper from "@/components/SlotWrapper";
import AppointmentColorsLegend from "@/Scheduler/AppointmentColorsLegend.vue";
import CheckAvailabilityModal from "./CheckAvailabilityModal.vue";
import ScheduleBoard from "./ScheduleBoard.vue";
import ScheduleBoardFilters from "./ScheduleBoardFilters.vue";

const store = useStore();
const stylesLoaded = ref(false);
const filterModal = ref(false);
const title = computed(() =>
  moment(store.state.scheduleBoardFilters.start).format("ddd MMM Do, YYYY")
);

onBeforeMount(async () => {
  try {
    await import("./scheduler_tailwind.css");
    stylesLoaded.value = true;
  } catch (e) {
    stylesLoaded.value = true;
  }
});
onMounted(() => store.dispatch("fetchDepartments"));

const toggleFilterModal = () => (filterModal.value = !filterModal.value);

defineExpose({ stylesLoaded });
</script>

<style lang="scss" scoped>
.schedule-board-filters {
  z-index: 2;
}
.schedule-board {
  z-index: 1;
  position: sticky;
  top: 0;
}

:deep(.row) {
  height: 100%;
}
.schedule-board-date {
  font-weight: 400 !important;
  color: var(--font-body-color);
}
</style>
